import { render } from "./AposWidgetControls.vue?vue&type=template&id=354c219e&scoped=true"
import script from "./AposWidgetControls.vue?vue&type=script&lang=js"
export * from "./AposWidgetControls.vue?vue&type=script&lang=js"

import "./AposWidgetControls.vue?vue&type=style&index=0&id=354c219e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354c219e"],['__file',"area/ui/apos/components/AposWidgetControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "354c219e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('354c219e', __exports__)) {
    api.reload('354c219e', __exports__)
  }
  
  module.hot.accept("./AposWidgetControls.vue?vue&type=template&id=354c219e&scoped=true", () => {
    api.rerender('354c219e', render)
  })

}


export default __exports__